"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailJSResponseStatus = void 0;
var EmailJSResponseStatus = /** @class */function () {
  function EmailJSResponseStatus(httpResponse) {
    this.status = httpResponse.status;
    this.text = httpResponse.responseText;
  }
  return EmailJSResponseStatus;
}();
exports.EmailJSResponseStatus = EmailJSResponseStatus;